import { render } from "./ParentBookingview.vue?vue&type=template&id=ab1f9482&scoped=true"
import script from "./ParentBookingview.vue?vue&type=script&lang=js"
export * from "./ParentBookingview.vue?vue&type=script&lang=js"

import "./ParentBookingview.vue?vue&type=style&index=0&id=ab1f9482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab1f9482"]])

export default __exports__